(() => {
 const syncComplement = cart => {
  if (!cart || !Array.isArray(cart.items)) return;
  document.querySelectorAll('[data-complement-product]').forEach(card => {
   card.hidden = cart.items.some(item => String(item.product_id) === card.dataset.complementProduct);
  });
 };
 const init = () => {
  if (window.FoxTheme?.pubsub) window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, event => syncComplement(event.cart));
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

(() => {
 const revealStrengthDetail = (hash, focus = true) => {
  if (!hash) return;
  let id;
  try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
  const target = document.getElementById(id);
  if (!target?.matches('details[data-mf-strength-detail]')) return;
  target.open = true;
  requestAnimationFrame(() => {
   if (focus) target.querySelector('summary')?.focus({ preventScroll: true });
   target.scrollIntoView({ block: 'start', behavior: 'auto' });
  });
 };
 document.addEventListener('click', event => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('a[href^="#MamataFormulaChoices-"]');
  if (link) revealStrengthDetail(link.hash);
 });
 window.addEventListener('hashchange', () => revealStrengthDetail(window.location.hash));
 const init = () => revealStrengthDetail(window.location.hash, false);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
